import { useForm, zodResolver } from '@mantine/form';
import { useNavigate, useRouter } from '@tanstack/react-router';
import { z } from 'zod';

import { useForgotPasswordMutation } from '@/shared/api/requests';
import { VALIDATE } from '@/shared/constants/validation';

export const useVerifyEmailForm = () => {
  const router = useRouter();
  const navigate = useNavigate();
  const form = useForm<{ email: string }>({
    validateInputOnChange: true,
    initialValues: {
      email: ''
    },
    validate: zodResolver(
      z.object({
        email: VALIDATE.EMAIL
      })
    )
  });

  const nextStep = () => {
    navigate({
      to: '/auth/forgot-password/confirmation',
      search: {
        email: form.getValues().email
      },
      mask: {
        to: '',
        search: {}
      }
    });
  };

  const forgotPasswordMutation = useForgotPasswordMutation({
    options: {
      onError: (error) => {
        if (error.response?.data.Errors) {
          form.setFieldError('email', error.response?.data.Errors?.email);
        }
        form.setFieldError('email', error.response?.data.Detail);
      },
      onSuccess: () =>
        // data
        {
          // notifications.show({
          //   title: data.data.resetCode,
          //   ...notificationStyleConfig
          // });
          nextStep();
        }
    }
  });

  const onSubmit = form.onSubmit(async () => {
    await forgotPasswordMutation.mutateAsync({
      params: { email: form.values.email }
    });
  });

  const abort = () => {
    router.history.back();
  };

  return {
    state: {
      form
    },
    functions: {
      abort,
      onSubmit
    }
  };
};
